import React,{useState,}from 'react'
import { Modal, } from 'antd';
import FundDesc from './FundDesc';
function FundCheck(props) {
    const [open,setOpen] = useState();
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.text==='查看' ? '查看':'已转账'}</a>
            <Modal                 
                open={open} 
                onOk={() => {setOpen(true)}} 
                onCancel={() => {setOpen(false)}} 
                okText='关闭' 
                width={1280}
                footer={null}
            >
                <FundDesc 
                    ecal_id={props.ecal_id}
                />       
            </Modal>
        </>
    )
}

export default FundCheck